import React, { useState } from 'react'
import { Button, IconButton, Tooltip, useDisclosure, useToast } from '@chakra-ui/react'
import { FaWhatsapp } from 'react-icons/fa'
import { useRoleta } from '../hooks/RoletaContext'
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  AlertDialogCloseButton,
} from '@chakra-ui/react'

export const BotaoWhatsApp = ({ cliente }) => {
  const [isLoading, setIsLoading] = useState(false)
  const { chamarClienteWhatsapp } = useRoleta()
  const { isOpen, onOpen, onClose } = useDisclosure()
  const toast = useToast()

  const handleChamarCliente = async () => {
    try {
      setIsLoading(true)

      await chamarClienteWhatsapp(cliente.codigo_cliente)

      toast({
        title: 'Cliente chamado com sucesso',
        status: 'success',
        duration: 3000,
        isClosable: true,
      })

      onClose()
    } catch (error) {
      toast({
        title: 'Erro ao chamar cliente',
        description: error.message || 'Não foi possível iniciar a chamada. Tente novamente.',
        status: 'error',
        duration: 4000,
        isClosable: true,
      })
    } finally {
      setIsLoading(false)
    }
  }

  return <Confirmar isOpen={isOpen} onOpen={onOpen} onClose={onClose} cliente={cliente} isLoading={isLoading} onConfirm={handleChamarCliente} />
}

function Confirmar({ cliente, onConfirm, isLoading, onOpen, isOpen, onClose }) {
  const cancelRef = React.useRef()

  const handleConfirm = async (cliente) => {
    if (isLoading) return
    onConfirm(cliente)
  }

  return (
    <>
      <Tooltip label={`Chamar o cliente ${cliente.nome_cliente}`} fontSize="sm">
        <IconButton colorScheme="green" aria-label="Chamar cliente" fontSize="20px" icon={<FaWhatsapp />} onClick={onOpen} size="sm" />
      </Tooltip>

      <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Chamar Cliente
            </AlertDialogHeader>

            <AlertDialogCloseButton />

            <AlertDialogBody>Você tem certeza que deseja chamar o cliente {cliente.nome_cliente}?</AlertDialogBody>
            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Cancelar
              </Button>
              <Button colorScheme="green" bg="#8CC63F" ml={3} isLoading={isLoading} loadingText="Chamando..." onClick={() => handleConfirm(cliente)}>
                Chamar
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  )
}
